import { render, staticRenderFns } from "./SingleRadio.vue?vue&type=template&id=02160c71"
import script from "./SingleRadio.vue?vue&type=script&lang=js"
export * from "./SingleRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports